/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamOrganizacniJednotkaDenikSsl extends GContentBase<SeznamOrganizacniJednotkaDenikSslObj> {
        private seznamObj: SeznamOrganizacniJednotkaDenikSslObj & GContent;
        sslden: string;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamOrganizacniJednotkaDenikSslObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "SeznamOrganizacniJednotkaDenikSsl",
                contentCaption: "jres:29808097",
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_orj_txt}<br />{sslden_txt}"
                },
                gridSettings: {
                    columnOrder: this.getColumnOrder()
                }
            })
            this.seznamObj.sslden = this.sslden;
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }

        private getColumnOrder(): string {
            if (this.sslden == null || this.sslden == undefined)
                return "ixs_orj_txt,sslden,dat_zmena,zmenu_prov_txt"
            else 
                return "sslden,ixs_orj_txt,dat_zmena,zmenu_prov_txt"
        }
    }

    export class SeznamOrganizacniJednotkaDenikSslObj extends GAdmSeznamBase {
        ixs_orj: string;
        sslden: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailOrganizacniJednotkaDenikSsl", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailOrganizacniJednotkaDenikSsl",
                newRecord: isNew,
                ixs_orj: isNew == true ? ((this.ixs_orj) ? this.ixs_orj : null) : data.ixs_orj,
                sslden: isNew == true ? ((this.sslden) ? this.sslden : null) : data.sslden,
                subrada: isNew == true ? null : data.subrada,
                openFromdenikSsl: (this.sslden) ? true : false,
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:29802620").addField("gselectbox", Gordic.Prefabs.Select.ginsorj(), {
                name: "ixs_orj",
                model: "model.ixs_orj=value.ixs_orj",
                disabled: (this.ixs_orj) ? true : false
            }).addRow("jres:29808057").addField("gselectbox", Gordic.Prefabs.Select.sslsden(), {
                name: "sslden",
                model: "model.sslden=value.sslden",
                disabled: (this.sslden) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_orj)
                hardFilter["ixs_orj"] = this.ixs_orj
            if (this.sslden)
                hardFilter["sslden"] = this.sslden
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.OrganizacniJednotkaDenikSsl.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}#".format(data.ixs_orj, data.sslden, data.subrada),
                nazev: "{0} - {1}".format(data["ixs_orj_txt"], data["sslden"])
            }
        }
    }
}